export const validationMessage = {
  // Email
  emailRequired: "Email is required",
  enterValidEmail: "Please enter a valid email address",

  // Name
  enterFirstName: "Please enter a valid first name",
  enterLastName: "Please enter a valid last name",
  name: "Name is required",

  // Contact
  enterValidContact: "Please enter a valid contact no",
  enterContact: "Phone number is required",

  // URL
  enterValidUrl: "Please enter a valid URL",

  // Password
  passwordRequired: "Password is required",
  enterValidPassword:
    "Incorrect password. Password must contain at least one uppercase letter, one lowercase letter, one digit, one special character, and be at least 8 characters long.",
  passwordMismatch: "Passwords do not match",

  // Common
  required: "This field is required",

  // File
  fileType: "Only JPEG, PNG, and JPG files are allowed",
  fileSize: "Max file size allowed is 2 MB",

  // Gateway
  enterGateway: "Please enter a valid Gateway",

  // MAC Address
  enterValidMAC: "Please enter a valid MAC address",
};
